import { Trans } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { ClipDropdown, type ClipDropdownProps } from "@components/ClipDropdown/ClipDropdown";

export type CreateEntityMethodDropdownProps = ClipDropdownProps & {
  /** 业务卡片内容区，等价于 ClipDropdown 的 triggerNode */
  children?: React.ReactNode;
};

/**
 * Library > Create Entity（Product / Character）入口下拉菜单。
 *
 * 透传 ClipDropdown 全部 props；children 作为 triggerNode 的便捷写法。
 * 默认：header="Creation Method"、click 触发、bottomLeft、min-w-[254px]。
 */
export const CreateEntityMethodDropdown = ({
  children,
  header = <Trans>Creation Method</Trans>,
  trigger = ["click"],
  placement = "bottomLeft",
  overlayClassName,
  triggerNode,
  ...rest
}: CreateEntityMethodDropdownProps) => {
  return (
    <ClipDropdown
      header={header}
      trigger={trigger}
      placement={placement}
      overlayClassName={twMerge("min-w-[254px]", overlayClassName)}
      triggerNode={triggerNode ?? children}
      {...rest}
    />
  );
};
